
import React from "react";
import { Footer, HeaderNavi } from "@components";

export default function ResultLayout({ title, children }) {
  return (
    <main id="wrapper">
      <div id="container" className="sub">
        <HeaderNavi />
        <div id="contents">
          <div className="sub-container">
            <div className="sub-layout">
              <div className="sub-contact">
                <div className="page-title-wrap">
                  <h2><span className="icon-dot-circle"></span>{title}</h2>
                </div>
                {children}
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </main>
  );
}
